import { ROUTES } from '../../lib/routes';
import { navigate } from '../../router';
import { el } from '../../utils/dom';
import { ensureAdminOrLeave } from './manageGuard';

export function renderManagePage(root: HTMLElement): void {
  void ensureAdminOrLeave();

  const wrap = el('div', { className: 'ev123-page-manage' });

  wrap.append(
    el('div', { className: 'ev123-page-head ev123-page-head--archive' }, [
      el('div', { className: 'ev123-container' }, [
        el('p', { className: 'ev123-portal-eyebrow', text: '관리자 모드' }),
        el('h1', {
          className: 'ev123-page-head__title',
          text: 'EV123 관리자 대시보드',
        }),
        el('p', {
          className: 'ev123-page-head__lead',
          text: '자료실과 설치사례 콘텐츠를 등록·수정하고 게시 상태를 관리할 수 있습니다.',
        }),
        el('p', {
          className: 'ev123-page-head__note ev123-card__desc',
          text: '관리자 전용 영역입니다. 일반 사용자에게는 노출되지 않습니다.',
        }),
      ]),
    ]),
  );

  const container = el('div', { className: 'ev123-container ev123-stack' });

  const grid = el('div', { className: 'ev123-manage-grid' });

  grid.appendChild(
    buildCard({
      eyebrow: '콘텐츠 관리',
      title: '자료실 관리',
      desc: '공지사항, 법령정보, 업무자료, 관련뉴스 게시글을 등록·수정·게시 관리합니다.',
      actionLabel: '자료실 관리 열기',
      actionPath: ROUTES.manageResources,
    }),
  );

  grid.appendChild(
    buildCard({
      eyebrow: '콘텐츠 관리',
      title: '설치사례 관리',
      desc: '시설 유형별 전기차충전기 설치사례를 등록·수정하고 게시 여부와 상단고정을 관리합니다.',
      actionLabel: '설치사례 관리 열기',
      actionPath: ROUTES.manageInstallCases,
    }),
  );

  container.appendChild(grid);
  wrap.appendChild(container);
  root.appendChild(wrap);
}

function buildCard(opts: {
  eyebrow: string;
  title: string;
  desc: string;
  actionLabel: string;
  actionPath: string;
}): HTMLElement {
  const card = el('div', { className: 'ev123-card ev123-manage-card' });
  card.append(
    el('p', { className: 'ev123-portal-eyebrow', text: opts.eyebrow }),
    el('h2', { className: 'ev123-card__title', text: opts.title }),
    el('p', { className: 'ev123-card__desc', text: opts.desc }),
  );
  const actions = el('div', { className: 'ev123-hero__actions ev123-hero__actions--tight' });
  const btn = el('button', {
    type: 'button',
    className: 'ev123-btn ev123-btn--primary ev123-btn--pill ev123-btn--sm',
    text: opts.actionLabel,
  }) as HTMLButtonElement;
  btn.addEventListener('click', () => navigate(opts.actionPath as never));
  actions.appendChild(btn);
  card.appendChild(actions);
  return card;
}
